'use strict';

var _require = require('./baseProperties'),
    baseProperties = _require.baseProperties;

module.exports.PersonIdentTypSchema = {
  title: 'PersonIdentTyp',
  type: 'object',
  properties: Object.assign({}, baseProperties)
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/personIdentTyp.js
// module id = BxPs
// module chunks = 0